'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Groupings$$anon$2(outer) {
  this.aWX = null;
  this.aWV = null;
  this.aWW = false;
  this.aWT = null;
  this.aWU = false;
  this.aWY = false;
  this.aWZ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aWX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Groupings$$anon$2 as $c_Lpresto_Groupings$$anon$2 };
$p = $c_Lpresto_Groupings$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Groupings$$anon$2;
/** @constructor */
function $h_Lpresto_Groupings$$anon$2() {
}
export { $h_Lpresto_Groupings$$anon$2 as $h_Lpresto_Groupings$$anon$2 };
$h_Lpresto_Groupings$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aWX;
});
$p.t = (function() {
  if ((!this.aWW)) {
    this.aWV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aWW = true;
  }
  return this.aWV;
});
$p.ag = (function() {
  if ((!this.aWU)) {
    this.aWT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().Tm(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aWU = true;
  }
  return this.aWT;
});
$p.v = (function() {
  if ((!this.aWZ)) {
    this.aWY = false;
    this.aWZ = true;
  }
  return this.aWY;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Groupings$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Groupings$$anon$2, "presto.Groupings$$anon$2", ({
  Jx: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Groupings$$anon$2 as $d_Lpresto_Groupings$$anon$2 };
//# sourceMappingURL=presto.-Groupings$$anon$2.js.map
